// extracted by mini-css-extract-plugin
export default {"wrapper":"Landing_wrapper__ofP5H","h1":"Landing_h1__AGfe9","start":"Landing_start__Ng2nL","h2":"Landing_h2__bNm49","h3":"Landing_h3__OuHDu","h4":"Landing_h4__QOoiY"};